import { call, fork, put, takeLatest } from 'redux-saga/effects';
import {
    getDashboardSeenNotifications,
    setDashboardSeenNotification,
} from '@/services/ApiCategories/dashboardSeenNotifications';
import { GetDashboardSeenNotificationsSuccess } from '@/store/dashboardSeenNotifications/actions';
import {
    DashboardSeenNotificationsActionTypes,
    UpdateDashboardSeenNotificationAction,
} from '@/store/dashboardSeenNotifications/types';
import { errorToast } from './commonGenerators/errorToast';

function* getDashboardSeenNotificationsSaga(): any {
    try {
        const reponse = yield call(getDashboardSeenNotifications);
        yield put(GetDashboardSeenNotificationsSuccess(reponse.data));
    } catch (e) {
        yield call(errorToast, e);
    }
}

function* updateDashboardSeenNotification(action: UpdateDashboardSeenNotificationAction): any {
    try {
        const { payload } = action;
        yield call(setDashboardSeenNotification, payload.notification);
    } catch (e) {
        yield call(errorToast, e);
    }
}

function* watchGetDashboardSeenNotificationsSaga(): any {
    yield takeLatest(
        DashboardSeenNotificationsActionTypes.GET_DASHBOARD_SEEN_NOTIFICATIONS,
        getDashboardSeenNotificationsSaga
    );
}

function* watchUpdateDashboardSeenNotificationSaga(): any {
    yield takeLatest(
        DashboardSeenNotificationsActionTypes.UPDATE_DASHBOARD_SEEN_NOTIFICATION,
        updateDashboardSeenNotification
    );
}

const dashboardSeenNotificationsSagas = [
    fork(watchGetDashboardSeenNotificationsSaga),
    fork(watchUpdateDashboardSeenNotificationSaga),
];

export default dashboardSeenNotificationsSagas;
